// src/stone/icons/ArrowFillLeft.tsx
import { jsx } from "react/jsx-runtime";
var ArrowFillLeft = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 6 12",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "currentcolor",
        d: "M.22 11.78a.75.75 0 0 0 1.06 0l4.321-4.763a1.494 1.494 0 0 0 0-2.032v-.003L1.281.219A.75.75 0 0 0 0 .751v10.5c0 .199.08.389.22.53"
      }
    )
  }
);
var ArrowFillLeft_default = ArrowFillLeft;

export {
  ArrowFillLeft_default
};
